module.exports = __webpack_public_path__ + "assets/img/22_218_big.4c62c9bb.jpg";